import * as tslib_1 from "tslib";
import { domainConnectFetchDomainService } from 'owa-domain-connect';
import { orchestrator } from 'satcheljs';
import setDomainState from '../mutators/setDomainState';
import { getDomainState } from '../actions/getDomainState';
export default orchestrator(getDomainState, function getDomainState() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, domainConnectFetchDomainService()];
                case 1:
                    response = _a.sent();
                    setDomainState(response);
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=getDomainState.js.map